import React from 'react'
import { Row, Col, FloatButton } from 'antd';
import "./Footer.css"

const { BackTop } = FloatButton;

export default function Footer() {
  return (    
	<div className="footer">
	<Row justify="center" className="container_index">
	  <Col xs={24} sm={24} md={20} lg={16} xl={14} xxl={12}>
		<div className="f_bot">
		  <div className="nav_bar_2">
			<p className="text">
			  <a href="https://www.360ep.cn/">首页</a>&nbsp;|
			  <a href="https://www.360ep.cn/news/about.php">关于我们</a>&nbsp;|
			  <a href="https://www.360ep.cn/news/contact.php">联系我们</a>&nbsp;|
			  <a href="https://www.360ep.cn/news/statement.php">隐私声明</a>&nbsp;|
			  <a href="https://www.360ep.cn/news/service_agreement.php">服务协议</a>&nbsp;|
			  <a href="https://www.360ep.cn/news/map.php">网站地图</a>&nbsp;|
			</p>
			<p className="text">
			  工作时间：周一到周六 早上8:30-17:30 &nbsp;
			  &nbsp;&nbsp;&nbsp; 咨询电话：400-692-8289 &nbsp;&nbsp;&nbsp;&nbsp;
			  <img src="https://www.360ep.cn/skin/360ep/image/beian.png" alt="" />&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;沪公网安备 31011602001225号
			</p>
			<p className="text">
			  ICP:
			  <a href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" nofollow="true">
				沪ICP备15053384号-3 ) Copyright 2020－2022 今塑网(www.360ep.cn),All Rights Reserved.
			  </a>
			</p>
			<p className="text icon_img">
			  <a href="https://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&amp;serial=9031000020160422234909000000700270-SAIC_SHOW_310000-4028e4cb641aec4601642994c4b517be335&amp;signData=MEUCIC0Aa/VDPd7t91OKO+Ut499AwKi5wKZx0MrkDjRkXeU1AiEAiiR8Oej2P6yFP5Yyw/xhQVNzBg/xqHViWg9BEDxDonM=">
				<img src="https://www.360ep.cn/skin/360ep/image/wangluogongshang.jpg" alt="" />
			  </a>
			  <a id="_pingansec_bottomimagelarge_shiming" target="_blank" rel="noopener noreferrer" href="//si.trustutn.org/info?sn=142220402040929114848&amp;certType=1">
				<img src="//v.trustutn.org/images/cert/bottom_large_img.png" alt="" />
			  </a>
			  <a className="record_img" href="https://www.163.com/dy/article/GT9JNESR0514CILN.html">
                  <img src="https://www.360ep.cn/skin/360ep/image/pinpai.jpg" alt="" />
                </a>
              </p>
            </div>
          </div>
        </Col>
      </Row>     
	  <BackTop />
    </div>
  );
};

